import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'lib/store';
import { DBUser } from 'db/schema/users';

type User = {
  email?: string;
  family_name?: string;
  given_name?: string;
  id: string;
  auth0_id: string;
  hubspot_id: string | null;
  medicare_number: string | null;
  birthdate: string | null;
  gender: string | null;
  tobacco: boolean | null;
  pcp_visits: string | null;
  specialist_visits: string | null;
  hospital_visits: string | null;
  income: number | null;
  filing_status: string | null;
  currently_married: boolean | null;
  pharmacy_type: string | null;
  hearing_aids: boolean | null;
  recommendation_type: string | null;
  last_slug: string | null;
  medicare_education_completion_count: number | null;
};

const initialState: User = {
  email: '',
  family_name: '',
  given_name: '',
  id: '',
  auth0_id: '',
  hubspot_id: null,
  medicare_number: null,
  birthdate: null,
  gender: null,
  tobacco: null,
  pcp_visits: null,
  specialist_visits: null,
  hospital_visits: null,
  income: null,
  filing_status: null,
  currently_married: null,
  pharmacy_type: null,
  hearing_aids: null,
  recommendation_type: null,
  last_slug: null,
  medicare_education_completion_count: null,
};

const userSlice = createSlice({
  initialState: initialState,
  name: 'user',
  reducers: {
    setUserAuth: (
      prevState,
      action: PayloadAction<{
        email: string;
        family_name: string;
        given_name: string;
      }>
    ) => {
      const { email, given_name, family_name } = action.payload;

      return {
        ...prevState,
        email,
        given_name,
        family_name,
      };
    },
    setUserDatabase: (prevState, action: PayloadAction<DBUser>) => {
      const {
        id,
        auth0_id,
        hubspot_id,
        medicare_number,
        birthdate,
        gender,
        tobacco,
        pcp_visits,
        specialist_visits,
        hospital_visits,
        income,
        filing_status,
        currently_married,
        pharmacy_type,
        hearing_aids,
        recommendation_type,
        last_slug,
        medicare_education_completion_count,
      } = action.payload;

      return {
        ...prevState,
        id,
        auth0_id,
        hubspot_id,
        medicare_number,
        birthdate,
        gender,
        tobacco,
        pcp_visits,
        specialist_visits,
        hospital_visits,
        income,
        filing_status,
        currently_married,
        pharmacy_type,
        hearing_aids,
        recommendation_type,
        last_slug,
        medicare_education_completion_count,
      };
    },
  },
});

const { actions, reducer } = userSlice;

export const { setUserDatabase } = actions;

export const selectUser = (state: RootState) => state.user;
export const selectBirthday = (state: RootState) => state.user.birthdate;

export default reducer;
